export class ObjectFormat {
  constructor(
    public color?: string,
    public bold?: boolean,
    public italic?: boolean,
    public id?: number,
    public parentId?: number,
    public decorator?: string,
    public slash?: boolean
  ) {}

  getColor(): string | undefined {
    return this.color;
  }
  getBold(): boolean | undefined {
    return this.bold;
  }
  getItalic(): boolean | undefined {
    return this.italic;
  }
  getDecorator(): string | undefined {
    return this.decorator;
  }
  getSlash(): boolean | undefined {
    return this.slash;
  }
  getId(): number | undefined {
    return this.id;
  }
  getParentId(): number | undefined {
    return this.parentId;
  }

  clone(): ObjectFormat {
    return new ObjectFormat(
      this.color,
      this.bold,
      this.italic,
      this.id,
      this.parentId,
      this.decorator,
      this.slash
    );
  }

  static merge(
    a: ObjectFormat | undefined,
    b?: ObjectFormat | undefined
  ): ObjectFormat | undefined {
    if (!a && !b) return undefined;

    if (!b) return a!.clone();
    if (!a) return b!.clone();

    return new ObjectFormat(
      b.color ?? a.color,
      b.bold ?? a.bold,
      b.italic ?? a.italic,
      b.id ?? a.id,
      b.parentId ?? a.parentId,
      b.decorator ?? a.decorator,
      b.slash ?? a.slash
    );
  }

  // true only when both are undefined, or when both exist and every field matches
  static areMergeCompatible(a?: ObjectFormat, b?: ObjectFormat): boolean {
    if (!a && !b) return true;
    if (!a || !b) return false;

    return (
      a.color === b.color &&
      a.bold === b.bold &&
      a.italic === b.italic &&
      a.id === b.id &&
      a.parentId === b.parentId &&
      a.decorator === b.decorator &&
      a.slash === b.slash
    );
  }
}
